import { render, staticRenderFns } from "./base-upload-dpwcc.vue?vue&type=template&id=c642054a&scoped=true"
import script from "./base-upload-dpwcc.vue?vue&type=script&lang=js"
export * from "./base-upload-dpwcc.vue?vue&type=script&lang=js"
import style0 from "./base-upload-dpwcc.vue?vue&type=style&index=0&id=c642054a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c642054a",
  null
  
)

export default component.exports